
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Typeahead} from 'react-bootstrap-typeahead';
import swal from 'sweetalert';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import Help from '../../generics/help';
import ModalOrientation from './modalOrientation';

var Config = require('../../../config');

class LabelPrint extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.changeComponent = this.changeComponent.bind(this);
		this.getGroup = this.getGroup.bind(this);
		this.getComponents = this.getComponents.bind(this);
		this.searching = this.searching.bind(this);
		this.changeCheck = this.changeCheck.bind(this);
		this.searchUnit = this.searchUnit.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.directPrint = this.directPrint.bind(this);

		//var aux_date = new Date();
		this.state = {
			search_by:"Unit",
			unit_number:"",
			code_component_list:[],
			isLoading: false,

			start_date:'',//aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date:'',//aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			start_folio:"",
			end_folio:"",
			blood_components: [],
			blood_component_id:"all",
			component_type:"all",
			components:[],
			list_group:[],
			group_rh:"all",

			tbl_list:[],

			preview_print:{},
			columns:[],
			check_all:false,
			status:"PENDIENTE DE ETIQUETA",
			type:'donation',
			convoke_places:[],
			convoke_places_id:"all",
			proc_big_label:"",
			disableStatus:false,
			printBlock:false,
		}
	}

	componentDidMount(){
		this.props.task_has_user_profiles.forEach((task)=>{
			if(task === 'PRINT_ALL_STATUS'){
				this.setState({disableStatus: true});
			}

			if(task === 'PRINT_LABEL_BLOCK'){
				this.setState({printBlock:true, search_by:'Block'});
			}
		})

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PROC_BIG_LABEL',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				proc_big_label: response.value
			});
		});

		this.getGroup();
		this.getComponents();
		//this.searching();

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=PRINT_BAG_LABELS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});

      	var hf = sessionStorage.getItem('health_facilities_id');

      	if(sessionStorage.getItem('matriz') === '1'){
      		hf = 'all';
      	}

      	fetch(Config.default.apiGateway.URL+'convoke_places/has_donations?health_facilities_id='+hf, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(e.target.name === 'search_by'){
			if(e.target.value === 'Block'){
				this.setState({tbl_list:[]});
				this.getGroup();
				this.getComponents();
				
			}else{
				this.setState({tbl_list:[], unit_number:"", code_component_list:[]});
			}
		}else if(e.target.name === 'type'){
			if(e.target.value !== 'folio'){
				var aux_date = new Date();
				this.setState({
					start_folio:"", 
					end_folio:"",
					start_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
					end_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
				});
			}else{
				this.setState({start_date:"", end_date:"", start_folio:"", end_folio:"",});
			}
		}else if(e.target.name === 'component_type'){
			if(e.target.value === 'all'){
				this.setState({blood_component_id:'all'});
			}else{
				setTimeout(()=>{
					this.getBloodComponent();
				}, 500);
			}
		}


	}

	changeComponent(e){
		if(e.length > 0){
			if(e[0].unit_status !== 'BLOQUEADA'){
				e[0].check = true;
				this.setState({
					tbl_list:e,
					unit_number:"",
					code_component_list:[]
				});

				document.getElementById('unit_number').focus();

				this._typeahead.getInstance().clear();
			}else{
				swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');
				this._typeahead.getInstance().blur();
				this._typeahead.getInstance().clear();
				this._typeahead.getInstance().focus();

			}
		}
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component/by_type?type='+this.state.component_type, {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({blood_components:response});
			}
		})
	}

	getGroup(){
		//this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			//this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					list_group: response
				});
			}
		});
	}

	getComponents(){
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
		//	this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					components: response
				});
			}
		});
	}

	searching(){
		this.props.waiting.handleShow('Cargando...');
		var obj = {
			start_date:this.state.start_date,
			end_date:this.state.end_date,
			start_folio:this.state.start_folio,
			end_folio:this.state.end_folio,
			component_type:this.state.component_type,
			group:this.state.group_rh === 'all' ? this.state.group_rh : this.state.group_rh.split(' ')[0],
			rh:this.state.group_rh === 'all' ? this.state.group_rh : this.state.group_rh.split(' ')[1],
			status:this.state.status,
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			blood_component_id:this.state.blood_component_id,
			convoke_places_id:this.state.convoke_places_id,
			search_by: this.state.type
		}
		fetch(Config.default.apiGateway.URL+'units/to_print_bag_label', {
			method: 'POST',
			body: JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({tbl_list:[], check_all:true});

				response.map((res)=>{
					res.check = true;
					this.setState({
						tbl_list:[...this.state.tbl_list, res]
					});
				})
			}
		});
	}

	changeCheck(e){
		if(e.target.name === 'check_all'){
			this.setState({check_all: e.target.checked ? true : false});

			this.state.tbl_list.map((t)=>{
				t.check = e.target.checked ? true : false
			})

			this.forceUpdate();
		}else{
			var id = parseInt(e.target.id.split('_')[1]);

			var index = this.state.tbl_list.findIndex(obj => obj.unit.id === id);
			if(this.state.tbl_list[index].check){
				this.state.tbl_list[index].check = false;
			}else{
				this.state.tbl_list[index].check = true;
			}

			this.forceUpdate();
		}
			
	}

	searchUnit(e){
		if(e.key === 'Enter'){
			this._typeahead.getInstance().clear();

			this.props.waiting.handleShow('Buscando...');
			fetch(Config.default.apiGateway.URL+'units/single_print_bag_label?unit_number='+this.state.unit_number,{
				method:'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					if(response.length > 0){
						this.setState({
							code_component_list: response
						});
						setTimeout(()=>{
							this._typeahead.getInstance().focus();
						}, 500);
						
					}else{
						swal('Error', 'Unidad no encontrada', 'error');
						
					}
				}
			});
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		
  			e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
      		      		
		}
  	}

  	onReturn(){
  		this.props.history.push('/');
  	}

  	onPrint(pos = ""){
  		var units = [];
  		var locked = "";
  		var valid = true;
  		this.state.tbl_list.map((t)=>{
  			if(t.check){
  				if(t.last_status === "BLOQUEADA"){
  					if(locked.indexOf(t.unit.unit_number) === -1){
  						locked += t.unit.unit_number+', ';
  					}
  				}
  				units.push(t.unit.id);
  			}
  		});

  		if(locked !== ""){
  			valid = false;
  			swal('Error', 'No es posible generar etiqueta de las unidades '+locked+' debido a que se encuentran bloqueadas', 'error');
  		}else if(units.length < 1){
  			valid = false;
  			swal('Error', 'Debe seleccionar al menos una unidad', 'error');
  		}


  		if(valid){
			if(pos !== ""){
				this.modal_orientation.handleClose();
			}
			this.printHL7(units);
  		}
  	}

	printHL7(items){
		var units = [];
		this.state.tbl_list.map((t)=>{
			if(t.check && !t.unit.label_bag_printed ){
				units.push(t.unit.id);
			}
		});
		this.props.waiting.handleShow('Generando...');
		fetch(Config.default.apiGateway.URL+'hl7_imss/entrada_almacen',{
			method: 'POST',
			body: JSON.stringify(units),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				this.props.waiting.handleClose();

				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.save(items);
			}
		})	
	}

	save(units){
		fetch(Config.default.apiGateway.URL+'labelsEditor/print_bag_labels?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id'),{
			method: 'POST',
			body: JSON.stringify(units),
			responseType:'blob',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
	          	res.text().then(function(result) {
	                swal('¡Error!', result, 'error');
	                return;
	          	});
	        }
			}).then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value === "NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					this.directPrint(response);	
				}
			}
			if(this.state.search_by === 'Block'){
				this.searching();
			}
			   
		})
	}

  	directPrint(response){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=> {
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"label_bags", "File": "'+aux[1]+'"}');
		}
	}

	setOrientation(){
		
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.labels.MAIN')}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_print_labels"}  />
				<form noValidate>
					<fieldset className="col-xs-12 form-group">
						<legend>Busqueda</legend>
						{this.state.printBlock &&
							<div className="col-xs-12 col-sm-1" style={{paddingTop:"5px", paddingLeft:'13px', paddingRight:'0'}}>
								<span className="span-min">Seleccione</span>
								<select name="search_by" id="search_by" value={this.state.search_by} 
									className="form-control" onChange={this.handleChange} style={{padding:"0 5px"}}
									onKeyPress={this.validateInput} autoFocus>
									<option value="">Seleccione</option>
									<option value="Unit">Unidad</option>
									<option value="Block">Bloque</option>
								</select>
							</div>
						}

						{this.state.search_by === 'Unit' ?
							<div style={{paddingTop:"5px"}}>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">No. Unidad</span>
									<input type="text" className="form-control" name="unit_number" id="unit_number" 
										value={this.state.unit_number} onChange={this.handleChange} 
										onKeyPress={this.searchUnit}  />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Codigo Componente</span>
									<Typeahead
							          	labelKey={(option) => `${option.component_code+' '+option.component_number}`}
							          	minLength={0}
							          	options={this.state.code_component_list.length > 0 ? this.state.code_component_list : []}
							          	onSearch={this.state.code_component_list.length > 0 ? this.state.code_component_list : []}
							          	onChange={this.changeComponent}
							            inputProps={{
							          		name:"code_component",
							          		id:"code_component"
							          	}}
							          	id="codeComponent"
							          	isLoading={this.state.isLoading}
							          	ref={ref => this._typeahead = ref}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
								</div>
							</div>
						: <div style={{paddingTop:"5px"}}>
							<div className="col-xs-12 col-sm-2" style={{paddingLeft:'14px', paddingRight:'2px'}}>
								<span className="span-min">Filtrar Por</span>
								<select className="form-control" name="type" id="type" value={this.state.value} 
									onChange={this.handleChange}>
									<option value="donation">Fecha Donación</option>
									<option value="process">Fecha Proceso</option>
									<option value="folio">Folio</option>
								</select>
							</div>
							<div className="col-xs-12">
								{this.state.type === 'donation' || this.state.type === 'process' ?
									<div className="col-xs-12 col-sm-1">
										<span className="span-min">Fecha Desde</span>
										<input type="date" className="form-control hour-input" name="start_date" id="start_date"
											value={this.state.start_date} onChange={this.handleChange}
											onKeyPress={this.validateInput} />
									</div>
								:null}
								{this.state.type === 'donation' || this.state.type === 'process' ?
									<div className="col-xs-12 col-sm-1">
										<span className="span-min">Fecha Hasta</span>
										<input type="date" className="form-control hour-input" name="end_date" id="end_date"
											value={this.state.end_date} onChange={this.handleChange}
											onKeyPress={this.validateInput} />
									</div>
								:null}
								
								{this.state.type === 'folio' ?
									<div className="col-xs-12 col-sm-1">
										<span className="span-min">Folio Desde</span>
										<input type="text" className="form-control" name="start_folio" id="start_folio"
											value={this.state.start_folio} onChange={this.handleChange} 
											onKeyPress={this.validateInput}/>
									</div>
								:null}
								{this.state.type === 'folio' ?
									<div className="col-xs-12 col-sm-1">
										<span className="span-min">Folio Hasta</span>
										<input type="text" className="form-control" name="end_folio" id="end_folio"
											value={this.state.end_folio} onChange={this.handleChange} 
											onKeyPress={this.validateInput}/>
									</div>
								:null}
								<div className="col-xs-12 col-sm-2">
									<span className="span-min"> Tipo Componente Sanguíneo</span>
									<select className="form-control" name="component_type" id="component_type"
										value={this.state.component_type} onChange={this.handleChange}
										onKeyPress={this.validateInput}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.components.map((c, i)=>{
											return <option key={i} value={c.key}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Componente Sanguíneo</span>
									<select className="form-control" name="blood_component_id" id="blood_component_id"
										value={this.state.blood_component_id} onChange={this.handleChange}
										onKeyPress={this.validateInput}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.blood_components.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.component}
											</option>
										})}
									</select>
								</div>
								<div className="col-xs-12 col-sm-1">
									<span className="span-min">Con Grupo</span>
									<select className="form-control" name="group_rh" id="group_rh"
										value={this.state.group_rh} onChange={this.handleChange}
										onKeyPress={this.validateInput}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.list_group.map((g, i)=>{
											return <option key={i} value={g.key_group+' '+g.key_rh}>
												{g.name}
											</option>
										})}
									</select>
								</div>

								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Estatus</span>
									<select className="form-control" name="status" id="status"
										value={this.state.status} onChange={this.handleChange}
										disabled={!this.state.disableStatus}
										onKeyPress={this.validateInput}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="DISPONIBLE">DISPONIBLE</option>
										<option value="PENDIENTE DE ETIQUETA">PENDIENTE DE ETIQUETA</option>
										<option value="RESERVADA">RESERVADA</option>
									</select>
								</div>

								<div className="col-xs-12 col-sm-1" style={{paddingTop:"10px"}}>
									<button type="button" className="btn btn-info" style={{fontSize:"1em"}}
										onClick={this.searching}>
										Buscar
									</button>
								</div>
							</div>
						</div>}

					</fieldset>

					<hr style={{width:"90%"}}/>

					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('CHECKBOX')}>
										<input type="checkbox" id={"check_all"} checked={this.state.check_all} name="check_all"
											value={this.state.check_all} onChange={this.changeCheck} />
											
									</th>
									<th hidden={this.showColumn('UNIT_NUMBER')}>No. Unidad</th>
									<th hidden={this.showColumn('COMPONENT_NUMBER')}>No. Componente</th>
									<th hidden={this.showColumn('COMPONENT')}>Componente</th>
									<th hidden={this.showColumn('GROUP_RH')}>Grupo & RH</th>
									<th hidden={this.showColumn('EXPIRED_DATE')}>Caducidad</th>
									<th hidden={this.showColumn('VOLUME')}>Volumen</th>
									<th hidden={this.showColumn('BAG_LABEL')}>Etiqueta de la Bolsa</th>
									<th>Estatus</th>
								</tr>
							</thead>
							<tbody>
								{this.state.tbl_list.map((l, i)=>{
									return <tr key={i}>
										<td hidden={this.showColumn('CHECKBOX')}>
											<input type="checkbox" id={"check_"+l.unit.id} checked={l.check}
												onChange={this.changeCheck} />
										</td>
										<td hidden={this.showColumn('UNIT_NUMBER')}>{l.unit.unit_number}</td>
										<td hidden={this.showColumn('COMPONENT_NUMBER')}>{l.unit.component_number}</td>
										<td hidden={this.showColumn('COMPONENT')}>{l.component_type}</td>
										<td hidden={this.showColumn('GROUP_RH')}>
											{l.unit.group} 
											{l.unit.rh === 'POSITIVO' ? '+' : l.unit.rh === 'NEGATIVO' ? '-' : ''}
										</td>
										<td hidden={this.showColumn('EXPIRED_DATE')}>{moment(l.unit.caducidad).format('DD/MM/YYYY H:mm')}</td>
										<td hidden={this.showColumn('VOLUME')} className="td-number">{l.unit.volume}</td>
										<td hidden={this.showColumn('BAG_LABEL')}>{l.unit.label_bag_printed ? 'CON ETIQUETA' : 'PENDIENTE DE ETIQUETA'}</td>
										<td>{l.last_status}</td>
									</tr>
								})}
							</tbody>
						</Table>
					</div>

					<div className="col-xs-12" style={{textAlign:'center'}}>
			        	<div>
							<RaisedButton className="action-btn" label={t('content.generics.buttons.print')} primary={true} 
								onClick={this.state.proc_big_label === 'NO' ? ()=>this.onPrint() : ()=>this.modal_orientation.handleShow()} 
							style={{margin:12}}/>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onReturn}/>
			        	</div>
			        </div>
				</form>

				<ModalOrientation {...this.props} onRef={ref => this.modal_orientation = ref} onPrint={this.onPrint} />

			</div>
		)
	}
}

export default translate('translations')(LabelPrint);